var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1111_3000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 157,
    height: 157,
    rx: 78.5,
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_3000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.802 107.448C141.89 105.978 140.278 105.099 138.491 105.099H98.6987C96.7262 105.099 94.9322 106.211 94.127 107.932L83.6021 130C83.9995 131.616 85.5087 132.823 87.3063 132.823H129.643C131.453 132.823 133.107 131.799 133.915 130.18L143.013 111.946C143.731 110.503 143.651 108.822 142.802 107.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9847 104.538C92.7889 102.817 94.5834 101.704 96.5563 101.704H134.028V96.9115C134.028 94.9358 132.361 93.3281 130.312 93.3281H108.463C108.431 93.3281 108.409 93.3199 108.401 93.3139L104.49 87.8459C103.798 86.8759 102.654 86.2969 101.432 86.2969H87.2161C85.1667 86.2969 83.5 87.9045 83.5 89.8803V122.327L91.9847 104.538Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1111_3000",
    x: 0.700001,
    y: 0.700001,
    width: 225.6,
    height: 225.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1111_3000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1111_3000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_3000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(83.5 79.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.722c43343e696855255223d52b77de92.svg";
export { ForwardRef as ReactComponent };